import React from "react";

const Header = () => {
  return (
    <div className="p-0 m-0">
      <iframe
      title="coin"
        src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=dark&pref_coin_id=1505&invert_hover=no"
        width="100%"
        height="36px"
        scrolling="auto"
        marginwidth="0"
        marginheight="0"
        frameborder="0"
        border="0"
      ></iframe>
    </div>
  );
};

export default Header;
